(function () {
    'use strict';

    angular
        .module('ib-seat-map-module')
        .directive('collapseCloseLegend', collapseCloseLegend);

    collapseCloseLegend.$inject = ['$document','$animate', '$timeout', '$rootScope'];
    function collapseCloseLegend ($document, $animate, $timeout, $rootScope) {
        return {
            restrict: 'AE',
            link: link
        };
        function link (scope) {
            const element = angular.element('[collapse-close-legend]');
            $animate.addClass(element, 'fadeInDown').then(() => {
                $animate.removeClass(element, 'fadeInDown');
                $timeout(() => {
                    scope.$apply(() => {
                        $animate.addClass(element, 'fadeOutDown');
                        $rootScope.$broadcast('closeLeyendCollapse');
                    });
                }, 3000);
            });
        }
    }
})();